module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dropdown",
    staticClass: "dropdown-wrap"
  }, [_c('label', {
    staticClass: "label input__label"
  }, [_vm._v(_vm._s(this.label))]), _vm._v(" "), _c('button', {
    class: _vm.setButtonClass,
    attrs: {
      "active": false
    },
    on: {
      "click": _vm.setActive
    }
  }, [_c('span', {
    staticClass: "button__text"
  }, [_vm._v(_vm._s(_vm.setLabel()))]), _c('Icon', {
    attrs: {
      "icon": "chevron-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown__list-wrap"
  }, [_c('ul', {
    staticClass: "dropdown__list"
  }, _vm._l((_vm.getPrototype), function(item, index) {
    return _c('li', {
      staticClass: "dropwdown__item"
    }, [_c('input', {
      staticClass: "dropdown__input",
      attrs: {
        "id": _vm.id + '_' + index,
        "name": _vm.id + '[]',
        "type": "radio"
      },
      domProps: {
        "value": index,
        "checked": _vm.setValue === index
      },
      on: {
        "change": _vm.saveValue
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "dropdown__input-label",
      attrs: {
        "for": _vm.id + '_' + index
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getChoiceValue(item))
      },
      on: {
        "click": _vm.isCurrent
      }
    })])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-935f3e66!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dropdown.vue
// module id = 332
// module chunks = 0